<template>
    <div class="action-modal" style="display: flex">
        <slot name="triggerOutside" :show="showModal">
            <button
                class="button button--blank"
                type="button"
                style="padding: 0"
                @click="showModal = true"
            >
                <slot name="trigger">
                    <IconBin v-if="action === 'delete'" fill="#ff4588" />
                </slot>
            </button>
        </slot>
        <portal v-if="showModal" to="modals">
            <ConfirmModal
                name="action-modal"
                :title="title"
                :ok-label="actionText"
                @confirmed="run"
                @canceled="showModal = false"
            >
                <template #content>
                    <div>
                        <Spinner v-if="loading" />
                        <slot :item="item"></slot>
                        <TransitionExpand v-if="error">
                            <ErrorList :error="error" />
                        </TransitionExpand>
                    </div>
                </template>
            </ConfirmModal>
        </portal>
    </div>
</template>

<script>
import { IconBin } from '@speechki-frontend/shared/ui/icons';
import { ConfirmModal } from '@speechki-frontend/shared/ui/modals';
import TransitionExpand from '@speechki-frontend/shared/ui/TransitionExpand';
import { ErrorList } from '@speechki-frontend/shared/ui/forms';

export default {
    name: 'ActionModal',
    components: {
        ConfirmModal,
        TransitionExpand,
        ErrorList,
        IconBin,
    },
    props: {
        item: {
            required: true,
            type: Object,
        },
        action: {
            default: 'delete',
            type: String,
        },
        method: {
            type: Function,
            required: true,
        },
        actionText: {
            type: String,
            default: 'Delete',
        },
        actionDataAdapter: {
            type: Function,
            default: undefined,
        },
        actionDataField: {
            type: String,
            default: 'id',
        },
        event: {
            type: String,
            default: 'delete',
        },
        successText: {
            type: String,
            default: '',
        },
        errorText: {
            type: String,
            default: 'Error occured, please try again later',
        },
        title: {
            type: String,
            default: 'Make Action',
        },
    },
    data() {
        return {
            showModal: false,
            loading: false,
            error: null,
        };
    },
    computed: {
        arguments() {
            if (typeof this.actionDataAdapter === 'function') {
                return this.actionDataAdapter(this.item);
            }

            return this.item[this.actionDataField];
        },
    },
    methods: {
        show() {
            this.showModal = true;
        },
        async run() {
            try {
                this.loading = true;
                this.error = null;
                await this.method(this.arguments);
                this.$store.dispatch('pushToast', {
                    id: Date.now(),
                    type: 'success',
                    title: 'Success',
                    text: this.successText || '',
                });
                this.showModal = false;
                this.$emit(this.event, this.arguments);
            } catch (e) {
                this.error = e;
                this.$store.dispatch('pushToast', {
                    id: Date.now(),
                    type: 'error',
                    text: e,
                });
            } finally {
                this.loading = false;
            }
        },
    },
};
</script>
